import { selectExternalUrlsData } from 'redux/externalurls/selectors';
import { useAppSelector } from 'redux/store';

export const PretestSummaryClickHere = () => {
  const links = useAppSelector(selectExternalUrlsData);

  return {
    link: [
      { ...links?.pretest_general },
      {
        urlText:
          ', aby zapoznać się ze wskazówkami i poradami jak najlepiej dbać o swoje zdrowie psychiczne.',
      },
    ],
  };
};
export const PretestStrings = () => {
  const links = useAppSelector(selectExternalUrlsData);

  return {
    Manual: {
      header: 'Instrukcja',
      desc: [
        'Ten kwestionariusz pozwoli zobaczyć jaki jest Twój aktualny poziom odczuwanego stresu, lęku i negatywnych emocji.',
        'Odpowiedz na kolejnych 15 pytań patrząc na swoje odczucia, myśli i zachowania z perspektywy ostatnich dwóch tygodni.',
        'Oceń, jak często w przeciągu ostatnich dwóch tygodni pojawiały się u Ciebie opisane myśli, emocje i zachowania.',
      ],
      buttonDesc: 'Dalej ➔',
    },
    Summary: {
      header: 'Twój wynik',
      desc_result: {
        _low: {
          descHeader:
            'Wyniki testu pokazują, że aktualnie odczuwasz niski poziom stresu.',
          desc: [
            {
              str: [
                'Oznacza to, że dobrze radzisz sobie z codziennymi wyzwaniami, aktywnie angażujesz się w działania, potrafisz cieszyć się z drobnych i większych zdarzeń w Twoim życiu.',
                'Kliknij Kontynuuj, jeśli chcesz wypełnić szczegółową część testu.',
              ],
            },
            { ...PretestSummaryClickHere() },
          ],
        },
        _middle: {
          descHeader:
            'Wyniki testu pokazują, że aktualnie odczuwasz podwyższony poziom stresu.',
          desc: [
            {
              str: [
                'Oznacza to, że radzenie sobie z codziennymi wyzwaniami może wymagać od Ciebie większego wysiłku, czasem odczuwasz zniechęcenie, brak motywacji do działania lub niepokój, a pokonanie przeszkód może Ci sprawiać trudności.',
                'Kliknij Kontynuuj i wypełnij resztę testu, żeby dowiedzieć się więcej o przyczynach trudności, z którymi możesz się spotkać.',
              ],
            },
            { ...PretestSummaryClickHere() },
            {
              link: [
                {
                  urlText:
                    'Możesz też umówić się na rozmowę w poradni studenckiej — nasi specjaliści pomogą Ci odnaleźć najlepszą drogę do osiągnięcia tego, co dla Ciebie ważne. ',
                },
                { ...links?.pretest_contact_empatia_team },
              ],
            },
          ],
        },
        _high: {
          descHeader:
            'Wyniki testu pokazują, że aktualnie odczuwasz wysoki poziom stresu.',
          desc: [
            {
              str: [
                'Oznacza to, że prawdopodobnie ostatnio przeżywasz smutek i niepokój częściej i silniej niż większość Twoich kolegów. Często się martwisz i możesz odczuwać silne napięcie, rozdrażnienie i zniechęcenie do jakiegokolwiek działania.',
                'Pamiętaj, że podwyższony wynik sam w sobie niekoniecznie oznacza problem dotyczący zdrowia psychicznego. ',
                'Kliknij Kontynuuj i wypełnij resztę testu, żeby dowiedzieć się więcej o przyczynach trudności, z którymi można się spotkać.',
              ],
            },
            {
              str: [
                'Jeśli coś Cię niepokoi, najlepiej szybko zwróć się o pomoc do lekarza lub specjalisty. ',
              ],
            },
            {
              link: [{ ...links?.pretest_contact_empatia_team }],
            },
            {
              str: [
                'Tylko wykwalifikowany specjalista może ocenić stan Twojego zdrowia psychicznego na podstawie dokładnej diagnozy przy użyciu szeregu różnych narzędzi.',
              ],
            },

            { ...PretestSummaryClickHere() },
          ],
        },
      },
      buttonText: 'Kontynuuj ➔',
    },
  };
};
export const NotAloneStrings = () => {
  const links = useAppSelector(selectExternalUrlsData);

  return {
    h1: 'Możesz potrzebować pilnej pomocy specjalisty.',
    p1: [
      'Twoje odpowiedzi wskazują, że pojawiają się u Ciebie myśli, które mogą zagrażać Twojemu życiu lub bezpieczeństwu. Jeśli Twoje myśli są wyraźne i konkretne albo obawiasz się, że naprawdę możesz sobie coś zrobić - nie zwlekaj, działaj natychmiast. Napisz lub zadzwoń!',
    ],
    contact: { ...links?.alert_emergency_contact },
    p2: [
      'Jeśli natomiast na tę chwilę czujesz się bezpiecznie, ale myśli samobójcze lub wyobrażenia o śmierci pojawiają się u Ciebie od pewnego czasu oznacza to, że potrzebujesz pomocy i kontaktu ze specjalistą tak szybko, jak to możliwe.',
    ],
    link: [
      {
        urlText: 'Zachęcamy do nawiązania kontaktu z naszymi specjalistami: ',
      },
      { ...links?.alert_contact_empatia_team },
    ],
    buttonText: 'Kontynuuj ➔',
  };
};

export const TestFormStrings = () => {
  return {
    nextQuestion: 'Następne pytanie ➔',
    continue: 'Kontynuuj ➔',
  };
};
export const MainTestStrings = () => {
  return {
    Manual: {
      header: 'Instrukcja',
      desc: [
        'Poniżej zobaczysz 51 pytań, które odnosić się będą do różnych emocji, przekonań i zachowań.',
        'Każde twierdzenie może być w odniesieniu do Ciebie prawdziwe lub nieprawdziwe.',
        'Zastanów się i odpowiedz jak często pojawiają się u Ciebie opisane myśli, emocje i zachowania.',
      ],
      buttonDesc: 'Rozpocznij test',
    },
    Summary: {
      header: 'Dziękujemy za wypełnienie testu!',
      subHeader:
        'Prześlij wynik testu na adres e-mailowy lub pobierz go w formie PDF',
      button: {
        text: 'Pobierz raport jako PDF',
      },
      reportName: 'Raport_Empatia.pdf',
    },
    Preview: {
      header: 'Na podstawie udzielonych odpowiedzi można wnioskować, że...',
    },
    SummarySection: {
      header: 'Podsumowanie',
    },
  };
};

export enum EmailValidationStrings {
  empty = 'Brakuje znaków',
  missingAT = 'Brakuje symbolu @',
  missingDomain = 'Brakuje domeny po @',
  missingPrefix = 'Brakuje nazwy przed @',
  missingTopLevelDomain = 'Brakuje domeny najwyższego poziomu',
  topLevelDomain = 'Domena najwyższego poziomu jest za krótka',
  specialinDomain = 'W domenie występuje niedozwolony znak specjalny +',
  doubleATs = 'Występuje za dużo @',
  startsWithDot = 'Znajduje się kropka na początku',
  // eslint-disable-next-line no-useless-escape
  specials = `Występują niedozwolone znaki specjalne: !#$%^&*()_\-=[\]{};':"\\|,<>/?`,
  // eslint-disable-next-line no-useless-escape
  multipleSpecials = `Występuje za dużo symboli specjalnych !@#$%^&*()_+\-=[\]{};':"\\|,.<>/? po sobie`,
  nonAscii = 'Występują znaki lub litery spoza ASCII',
}

export const LoadingViewStrings = {
  h1: 'Daj nam chwilę!',
  p1: 'Trwa generowanie podsumowania testu.',
  p1Pretest: 'Trwa przygotowywanie testu.',
};

export const AdminPanel = {
  token: 'token',
  reportName: 'Raport_Empatia_admin.csv',
  userIdKeyName: 'username',
  oldPassword: 'Stare hasło',
  newPassword: 'Nowe hasło',
  SigIn: {
    h1: 'Panel logowania administratora',
    email: 'Adres e-mail',
    password: 'Hasło',
    logIn: 'Zaloguj się',
    reset: 'Zresetuj hasło',
  },
  Reset: {
    h1: 'Resetuj hasło',
    instruction:
      'Wprowadź adres e-mail swojego konta, aby otrzymać link do resetowania hasła.',
    email: 'E-mail',
    button: 'Wyślij link',
    return: 'Wróć na stronę logowania',
    Confirm: {
      h1: 'Ustaw nowe hasło',
      instruction:
        'Wprowadź hasło jakie będziesz wykorzystywać do logowania do systemu.',
      button: 'Zapisz hasło',
    },
  },
  ChangePassword: {
    h1: 'Zmień hasło',
  },
  AdminView: {
    h1: 'Panel administratora',
    passwordChanged: 'Hasło zostało zmienione',
    downloadReport: 'Pobierz raport',
    changePassword: 'Zmień hasło',
    logOut: 'Wyloguj się',
  },
  Errors: {
    Api: {
      invalidCredentials: 'Could not validate credentials',
      incorrectOldPassword: 'Incorrect oldPassword',
    },
    incorrectPassword: 'Podano niepoprawne hasło',
    incorrectEmailOrPassword: 'Niepoprawny adres e-mail lub hasło',
    invalidToken: 'Sesja wygasała, zaloguj się ponownie',
  },
};

export type ApiErrorTypes =
  | 'ERR_FR_TOO_MANY_REDIRECTS'
  | 'ERR_BAD_OPTION_VALUE'
  | 'ERR_BAD_OPTION'
  | 'ERR_NETWORK'
  | 'ERR_DEPRECATED'
  | 'ERR_BAD_RESPONSE'
  | 'ERR_BAD_REQUEST'
  | 'ERR_NOT_SUPPORT'
  | 'ERR_INVALID_URL'
  | 'ERR_CANCELED'
  | 'ECONNABORTED '
  | 'ETIMEDOUT '
  | 'NOT_FOUND';

export const ApiErrors: { [key: string]: { header: string; desc?: string } } = {
  ERR_FR_TOO_MANY_REDIRECTS: {
    header: 'Wystąpił błąd w momencie połączenia z serwerem.',
    desc: 'Wyjdź ze strony i spróbuj wykonać test od początku.',
  },
  ERR_BAD_OPTION_VALUE: {
    header:
      'Wystąpił błąd po naszej stronie, który uniemożliwia dalsze wypełnianie testu.',
    desc: 'Zostaliśmy o tym poinformowani i zajmiemy się tym najszybciej, jak to możliwe. Spróbuj wypełnić formularz później.',
  },
  ERR_BAD_OPTION: {
    header:
      'Wystąpił błąd po naszej stronie, który uniemożliwia dalsze wypełnianie testu.',
    desc: 'Zostaliśmy o tym poinformowani i zajmiemy się tym najszybciej, jak to możliwe. Spróbuj wypełnić formularz później.',
  },
  ERR_NETWORK: {
    header: 'Wystąpił błąd w momencie połączenia z serwerem.',
    desc: 'Wyjdź ze strony i spróbuj wykonać test od początku.',
  },
  ERR_DEPRECATED: {
    header:
      'Wystąpił błąd po naszej stronie, który uniemożliwia dalsze wypełnianie testu.',
    desc: 'Zostaliśmy o tym poinformowani i zajmiemy się tym najszybciej, jak to możliwe. Spróbuj wypełnić formularz później.',
  },
  ERR_BAD_RESPONSE: {
    header:
      'Wystąpił błąd po naszej stronie, który uniemożliwia dalsze wypełnianie testu.',
    desc: 'Zostaliśmy o tym poinformowani i zajmiemy się tym najszybciej, jak to możliwe. Spróbuj wypełnić formularz później.',
  },
  ERR_BAD_REQUEST: {
    header:
      'Wystąpił błąd po naszej stronie, który uniemożliwia dalsze wypełnianie testu.',
    desc: 'Zostaliśmy o tym poinformowani i zajmiemy się tym najszybciej, jak to możliwe. Spróbuj wypełnić formularz później.',
  },
  ERR_NOT_SUPPORT: {
    header:
      'Wystąpił błąd po naszej stronie, który uniemożliwia dalsze wypełnianie testu.',
    desc: 'Zostaliśmy o tym poinformowani i zajmiemy się tym najszybciej, jak to możliwe. Spróbuj wypełnić formularz później.',
  },
  ERR_INVALID_URL: {
    header:
      'Wystąpił błąd po naszej stronie, który uniemożliwia dalsze wypełnianie testu.',
    desc: 'Zostaliśmy o tym poinformowani i zajmiemy się tym najszybciej, jak to możliwe. Spróbuj wypełnić formularz później.',
  },
  ERR_CANCELED: {
    header: 'Wystąpił błąd w momencie połączenia z serwerem.',
    desc: 'Wyjdź ze strony i spróbuj wykonać test od początku.',
  },
  ECONNABORTED: {
    header: 'Wystąpił błąd w momencie połączenia z serwerem.',
    desc: 'Wyjdź ze strony i spróbuj wykonać test od początku.',
  },
  ETIMEDOUT: {
    header: 'Wystąpił błąd w momencie połączenia z serwerem.',
    desc: 'Wyjdź ze strony i spróbuj wykonać test od początku.',
  },
  NOT_FOUND: {
    header: 'Przepraszamy ale nie znaleźliśmy takiej strony.',
    desc: 'Sprawdź czy wpisany adres jest poprawny.',
  },
};
